<app-modal-open-padding-wrapper>
  <header #header [ngClass]="{ fixed: headerFixed, static: !headerFixed }">
    <div class="navbar" *ngIf="(authenticatedUser$ | async) !== null">
      <div class="h-100 container-fluid">
        <div class="m-0 w-100 h-100 d-flex justify-content-end">
          <div class="d-flex align-items-center justify-content-lg-end">
            <a routerLink="/home">
              <img
                class="logo"
                src="https://mmicdn.s3.eu-central-1.amazonaws.com/NutanixRaceToOlympics/Logo/Nutanix-Logo-Charcoal-Gray_Desktop_144dpi.png"
              />
            </a>
          </div>
          <div class="d-flex justify-content-end w-100">
            <div class="p-0 d-none d-lg-flex">
              <div class="h-100 navbar-wrapper" *ngIf="headerMenu">
                <div class="pe-3 h-100 lower-nav d-flex justify-content-end align-items-right">
                  <ng-container *ngFor="let item of headerMenu.items">
                    <ng-container *ngIf="item.items && item.items.length === 0">
                      <div
                        class="h-100 d-flex justify-content-center align-items-center navbar-item"
                        style="margin-right: 30px"
                        routerLinkActive="active"
                      >
                        <a [routerLink]="item.url" *ngIf="!item.url.includes('http')">
                          <span>{{ item.label }}</span>
                        </a>
                        <a [href]="item.url" target="_blank" *ngIf="item.url.includes('http')">
                          <span>{{ item.label }}</span>
                        </a>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.items && item.items.length > 0">
                      <div class="h-100 navbar-item dropdown my-accounts">
                        <a
                          [routerLink]="item.url"
                          routerLinkActive="active"
                          class="dropdown-toggle"
                          data-toggle="dropdown"
                          *ngIf="!item.url.includes('http')"
                          >{{ item.label }}</a
                        >
                        <a
                          [href]="item.url"
                          target="_blank"
                          class="dropdown-toggle"
                          data-toggle="dropdown"
                          *ngIf="item.url.includes('http')"
                          >{{ item.label }}</a
                        >
                        <ul class="dropdown-menu">
                          <ng-container *ngFor="let subItem of item.items">
                            <li>
                              <a
                                class="dropdown-item"
                                [routerLink]="subItem.url"
                                *ngIf="!subItem.url.includes('http')"
                                >{{ subItem.label }}</a
                              >
                              <a
                                class="dropdown-item"
                                [href]="subItem.url"
                                target="_blank"
                                *ngIf="subItem.url.includes('http')"
                                >{{ subItem.label }}</a
                              >
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="d-none d-lg-flex justify-content-end align-items-center icons-nav">
              <div class="pb-2">
                <lib-switch-back-to-admin-button></lib-switch-back-to-admin-button>
              </div>
              <lib-notification-bell-dropdown class="notification-bell"></lib-notification-bell-dropdown>
              <app-profile-menu class="ms-2 ms-xxl-3"></app-profile-menu>
            </div>
            <div class="d-lg-none col-9 h-100 navbar-wrapper-small flex-row">
              <app-main-menu [headerMenu]="headerMenu"></app-main-menu>
              <div class="d-flex justify-content-end align-items-center icons-nav">
                <lib-notification-bell-dropdown class="notification-bell"></lib-notification-bell-dropdown>
                <app-profile-menu class="ms-3"></app-profile-menu>
                <div class="pb-2">
                  <lib-switch-back-to-admin-button></lib-switch-back-to-admin-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar" *ngIf="(authenticatedUser$ | async) === null">
      <div class="w-100 h-100 container">
        <div class="w-100 h-100 row">
          <div class="col-9 col-sm-10">
            <div class="h-100 d-flex align-items-center">
              <a routerLink="/home">
                <img
                  class="logo-unauth"
                  src="https://mmicdn.s3.eu-central-1.amazonaws.com/NutanixRaceToOlympics/Logo/Nutanix-Logo-Charcoal-Gray_Desktop_144dpi.png"
                />
              </a>
            </div>
          </div>
          <div class="col-3 col-sm-2 p-0">
            <div class="h-100 d-flex align-items-center justify-content-end">
              <a routerLink="/auth/login" class="btn btn-primary btn-round btn-login">Login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</app-modal-open-padding-wrapper>
